<template>
    <v-select 
       :value="selected_gebr" 
       v-bind:items="filtered_users"
       item-value="code" 
       item-text="name" 
       :label="label"
       :dense="isDense" :clearable="isClearable"
       @change="updateData">
    </v-select>
</template>

<script>
export default {
    props: {
        selected_gebr: String,
        label: String,
        field: {
            default: 'gebr',
            required: true,
        },
        isClearable:{
            type: Boolean,
            default: false
        }, 
        showInactive: {
            type: Boolean,
            default: false
        },
        isDense:{
            type: Boolean,
            default: true
        },
        vfyEmailsOnly:{
            type: Boolean,
            default: false
        },
        isAgent:{
            type: Boolean,
            default: false
        },    
    },
    computed: {
        filtered_users: function() { // filter on user being active    
            return this.gebrcodes.filter(el => {
                let check_active = this.showInactive ? false : el.active;
                let check_email = this.vfyEmailsOnly ? el.email.includes('@villaforyou.com') : true;
                let check_agent = this.isAgent ? el.agent : true;
                return check_active && check_email && check_agent;
            });            
        },
    },    
    data() {
        return {
            gebrcodes: [],
        }
    },
    created() {
        this.getGebrCodes();
    },
    methods: {
        getGebrCodes() {
            this.$axios
                .post("ares/json/ares/misc/getGebr.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getGebr"
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log('error', res.data.error.message);
                    } else {
                        this.gebrcodes = res.data.getGebr;
                    }
                })
        },
        updateData(v){
            this.$emit('updateData', { "field": this.field, "value": v === null ? '' : v })
        }
    }
}

</script>